import labels from "src/constants/displayFields";
import { getDisplayRackLocations } from "src/utils/internalWorkOrderRackLocations";

export const getScanFields = asset => {
  if (!asset) {
    return [];
  }
  return [
    [asset.itemId, labels.item_id],
    [asset.barcode, labels.barcode_number],
    [asset.inventoryNumber, labels.inventory_number],
    [asset.skuNumber, labels.sku_number],
    [asset.batchNumber, labels.batch_number],
    [asset.itemCode, labels.item_code],
    [asset.serialNumber, labels.serial_number],
  ].filter(([value]) => value);
};

export const findItemsByMobileLocation = (items, scannedValue) => {
  if (!scannedValue) return [];
  const normalized = scannedValue.toLowerCase();
  return items.filter(item =>
    getDisplayRackLocations({ item }).some(loc => {
      const mbl = loc.mobile_warehouse_location;
      if (!mbl) return false;
      return mbl.location_id?.toLowerCase() === normalized || mbl.location_name?.toLowerCase() === normalized;
    })
  );
}; 